import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { Skeleton } from 'antd';
import moment from 'moment';
import styles from './styles.less';

const SmallCard = ({ blog }) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (Object.keys(blog).length) {
      setLoading(false);
    }
  }, [blog]);

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <LazyLoad offset={300}>
          <img src={blog.image} alt={blog.title} />
        </LazyLoad>
      </div>
      <div className={styles.titleContainer}>
        <Skeleton loading={loading} active>
          <span dangerouslySetInnerHTML={{ __html: blog.title }} />
          {blog.author && (
            <div className={styles.authorDate}>
              <span>{blog.author.name}</span>
              <span>{moment(blog.date).format('DD MMM')}</span>
            </div>
          )}
        </Skeleton>
      </div>
    </div>
  );
};

SmallCard.propTypes = {
  blog: PropTypes.object.isRequired,
};

export default SmallCard;
